export const EXEMPT_POLICIES_GET_INFO = 'EXEMPT_POLICIES_GET_INFO';
export const EXEMPT_POLICIES_GET_INFO_SUCCESS =
  'EXEMPT_POLICIES_GET_INFO_SUCCESS';
export const EXEMPT_POLICIES_GET_INFO_FAILURE =
  'EXEMPT_POLICIES_GET_INFO_FAILURE';
export const EXEMPT_POLICIES_UPDATE_SYSLOG_CONFIG =
  'EXEMPT_POLICIES_UPDATE_SYSLOG_CONFIG';
export const EXEMPT_POLICIES_UPDATE_ACCOUNT_OPTION =
  'EXEMPT_POLICIES_UPDATE_ACCOUNT_OPTION';
export const EXEMPT_POLICIES_RESET = 'EXEMPT_POLICIES_RESET';
export const EXEMPT_POLICIES_SAVE = 'EXEMPT_POLICIES_SAVE';
export const EXEMPT_POLICIES_SAVE_SUCCESS = 'EXEMPT_POLICIES_SAVE_SUCCESS';
export const EXEMPT_POLICIES_SAVE_FAILURE = 'EXEMPT_POLICIES_SAVE_FAILURE';

export const getAccountInfo = () => ({
  type: EXEMPT_POLICIES_GET_INFO,
});

export const getAccountInfoSuccess = data => ({
  type: EXEMPT_POLICIES_GET_INFO_SUCCESS,
  ...data,
});

export const getAccountInfoFailure = error => ({
  type: EXEMPT_POLICIES_GET_INFO_FAILURE,
  error,
});

export const updateAccountOption = options => ({
  type: EXEMPT_POLICIES_UPDATE_ACCOUNT_OPTION,
  options,
});

export const resetSettings = () => ({
  type: EXEMPT_POLICIES_RESET,
});

export const saveSettings = () => ({
  type: EXEMPT_POLICIES_SAVE,
});
export const saveSettingsSuccess = result => ({
  type: EXEMPT_POLICIES_SAVE_SUCCESS,
  result,
});
export const saveSettingsFailure = errors => ({
  type: EXEMPT_POLICIES_SAVE_FAILURE,
  errors,
});
